<template>
    <div class="experience mb-3">
        <div class="m-auto text-left control-width border shadow add-rounded p-4">
            <p class="text-danger text-center font-weight-bolder" v-if="error">
                {{ error }}
            </p>
            <div>
                <h5 class="my-3 kova-text">
                    Have you led a team for software project/product development?
                </h5>
                <a-radio-group v-model="project_leader">
                    <a-radio class="mb-2" :value="true" :style="radioStyle">
                        <span class="text-size2 mt-n1">
                            Yes
                        </span>
                    </a-radio>
                    <a-radio class="mb-2" :style="radioStyle" :value="false">
                        <span class="text-size2 mt-n1">
                            No
                        </span>
                    </a-radio>
                </a-radio-group>
            </div>

            <div v-if="project_leader">
                <h5 class="kova-text mt-3">
                    Number of projects/products you've built as a team leader
                </h5>
                <a-input
                    class="ml-2 w-50"
                    size="large"
                    :min="0"
                    :max="maxLinks"
                    type="number"
                    placeholder="0"
                    v-model.number="projects_led_count"
                /><br />
                <div :key="n + 'a'" v-for="n in projects_led_count">
                    <a-input
                        @change="handleChange2({ [n]: $event.target.value })"
                        class="mt-3 w-75"
                        :value="projects_led[n - 1] || ''"
                        addonBefore="https://"
                        placeholder="add project link"
                    /><br />
                </div>
            </div>

            <h5 class="kova-text mt-3 mb-2">
                Number of Remote projects completed?
            </h5>
            <span class="font-weight-bold">
                <a-input
                    class="ml-2 w-50"
                    size="large"
                    :min="0"
                    :max="maxLinks"
                    type="number"
                    placeholder="0"
                    v-model.number="numLink"
                />
            </span>
            <br />
            <div :key="n + 'b'" v-for="n in numLink">
                <a-input
                    class="mt-3 w-75"
                    @change="handleChange({ [n]: $event.target.value })"
                    addonBefore="https://"
                    :value="remote_projects_links[n - 1] || ''"
                    placeholder="add project link"
                />
                <br />
            </div>

            <h5 class="kova-text mt-3 mb-2">Education Experience</h5>
            <div class="row my-2 pl-2" :key="i + 'c'" v-for="(edu, i) in education">
                <div class="col-md-11">
                    <a-input
                        class="w-100"
                        size="large"
                        @change="handleEducation(i, 'institution', $event.target.value)"
                        @blur="storeEducationData"
                        :value="edu.institution"
                        placeholder="Name of Institution"
                    />
                </div>
                <div class="col-md-1">
                    <a-icon
                        class="close mt-2"
                        @click="removeEducation(i, edu.ID || edu.id)"
                        type="close-circle"
                        color="#FC0404"
                    />
                </div>

                <div class="col-md-6 mt-2">
                    <a-input
                        size="large"
                        class="w-100"
                        @change="handleEducation(i, 'course', $event.target.value)"
                        @blur="storeEducationData"
                        :value="edu.course"
                        placeholder="B.Sc Computer Science"
                    />
                </div>
                <div class="col-md-5 mt-2">
                    <a-select
                        size="large"
                        show-search
                        placeholder="Location"
                        class="w-100 mr-2"
                        @change="handleEducation(i, 'location', $event)"
                        @blur="storeEducationData"
                        :value="edu.location"
                    >
                        <a-select-option :value="item.name" v-for="(item, index) in countries" :key="index + 'd'">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-6 mt-2">
                    <a-select
                        size="large"
                        placeholder="Start Month"
                        show-search
                        class="w-100"
                        @blur="storeEducationData"
                        @change="edu.from = `${$event} ${edu.start_year || ''}`"
                        v-model="edu.start_month"
                    >
                        <a-select-option v-for="month in months" :key="month + 'e'" :value="month">
                            {{ month }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-5 mt-2">
                    <a-select
                        size="large"
                        show-search
                        placeholder="Start Year"
                        @blur="storeEducationData"
                        class="w-100"
                        @change="edu.from = `${edu.start_month || ''} ${edu.start_year}`"
                        v-model="edu.start_year"
                    >
                        <a-select-option key="preent" :value="thisYear">{{ thisYear }}</a-select-option>
                        <a-select-option v-for="n in 20" :key="n + 's'" :value="thisYear - n">
                            {{ thisYear - n }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-11 mt-2">
                    <a-checkbox
                        @blur="storeEducationData"
                        :checked="edu.to === 'Present'"
                        @change="
                            edu.to = edu.end_month = edu.end_year = $event.target.checked ? $event.target.value : ''
                        "
                        value="Present"
                    >
                        I am currently studying at this institution
                    </a-checkbox>
                </div>

                <div class="col-md-6 mt-2" v-if="edu.to !== 'Present'">
                    <a-select
                        size="large"
                        placeholder="End Month"
                        class="w-100"
                        @blur="storeEducationData"
                        show-search
                        v-model="edu.end_month"
                        @change="edu.to = `${$event} ${edu.end_year || ''}`"
                    >
                        <a-select-option v-for="month in months" :key="month + 'f'" :value="month">
                            {{ month }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-5 mt-2" v-if="edu.to !== 'Present'">
                    <a-select
                        size="large"
                        placeholder="End Year"
                        class="w-100"
                        show-search
                        @blur="storeEducationData"
                        v-model="edu.end_year"
                        @change="edu.to = `${edu.end_month || ''} ${$event}`"
                    >
                        <a-select-option key="prest">{{ thisYear }}</a-select-option>
                        <a-select-option v-for="n in 20" :key="n + 's'" :value="thisYear - n">
                            {{ thisYear - n }}
                        </a-select-option>
                    </a-select>
                </div>
                <!-- </div> -->
            </div>
            <div class="text-left pl-2">
                <a-button size="large" class="bg-light" @click="addEducation">
                    <a-icon type="plus" style="position: relative; bottom: 3px;" />
                    add
                </a-button>
            </div>

            <h5 class="kova-text mt-3 mb-2">Company Experience</h5>
            <div class="row mt-3 mb-2 pl-2" :key="i + 'g'" v-for="(job, i) in company">
                <div class="col-md-11">
                    <a-input
                        size="large"
                        class="w-100"
                        @change="handleCompany(i, 'organization', $event.target.value)"
                        @blur="storeCompanyData"
                        :value="job.organization"
                        placeholder="Name of Organization"
                    />
                </div>

                <div class="col-md-1">
                    <a-icon
                        class="close mt-2"
                        @click="removeCompany(i, job.ID || job.id)"
                        type="close-circle"
                        color="#FC0404"
                    />
                </div>
                <div class="col-md-6 mt-2">
                    <a-select
                        size="large"
                        placeholder="Role"
                        class="w-100"
                        show-search
                        @change="handleCompany(i, 'role', $event)"
                        @blur="storeCompanyData"
                        :value="job.role"
                    >
                        <a-select-option v-for="role in jobRoles" :key="role + 'h'" :value="role">
                            {{ role }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="col-md-5 mt-2">
                    <a-select
                        size="large"
                        show-search
                        placeholder="Location"
                        class="w-100 mr-2"
                        @change="handleCompany(i, 'location', $event)"
                        @blur="storeCompanyData"
                        :value="job.location"
                    >
                        <a-select-option :value="item.name" v-for="(item, index) in countries" :key="index + 'i'">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-6 mt-2">
                    <a-select
                        size="large"
                        show-search
                        placeholder="Start Month"
                        @blur="storeCompanyData"
                        class="w-100"
                        @change="job.from = `${$event} ${job.start_year || ''}`"
                        v-model="job.start_month"
                    >
                        <a-select-option v-for="month in months" :key="month + 'j'" :value="month">
                            {{ month }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-5 mt-2">
                    <a-select
                        size="large"
                        placeholder="Start Year"
                        @blur="storeCompanyData"
                        class="w-100"
                        show-search
                        @change="job.from = `${job.start_month || ''} ${$event}`"
                        v-model="job.start_year"
                    >
                        <a-select-option key="ccc" :value="thisYear">{{ thisYear }}</a-select-option>
                        <a-select-option v-for="n in 20" :key="n + 's'" :value="thisYear - n">
                            {{ thisYear - n }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-11 mt-2">
                    <a-checkbox
                        @blur="storeCompanyData"
                        :checked="job.to === 'Present'"
                        @change="
                            job.to = job.end_month = job.end_year = $event.target.checked ? $event.target.value : ''
                        "
                        value="Present"
                    >
                        I am currently working in this role
                    </a-checkbox>
                </div>

                <div class="col-md-6 mt-2" v-if="job.to !== 'Present'">
                    <a-select
                        size="large"
                        placeholder="End Month"
                        class="w-100"
                        @blur="storeCompanyData"
                        show-search
                        v-model="job.end_month"
                        @change="job.to = `${$event} ${job.end_year || ''}`"
                    >
                        <a-select-option v-for="month in months" :key="month + 'k'" :value="month">
                            {{ month }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="col-md-5 mt-2" v-if="job.to !== 'Present'">
                    <a-select
                        show-search
                        @blur="storeCompanyData"
                        size="large"
                        placeholder="End Year"
                        class="w-100"
                        v-model="job.end_year"
                        @change="job.to = `${job.end_month || ''} ${$event}`"
                    >
                        <a-select-option :value="thisYear" key="apres">{{ thisYear }}</a-select-option>
                        <a-select-option v-for="n in 20" :key="n + 's'" :value="thisYear - n">
                            {{ thisYear - n }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="text-left pl-2">
                <a-button size="large" class="bg-light" @click="addCompany">
                    <a-icon type="plus" style="position: relative; bottom: 3px;" />
                    add
                </a-button>
            </div>

            <div class="container-fluid px-0 px-md-4 mb-5 mt-5" v-if="!overview">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack">
                            Back
                        </button>
                    </div>
                    <div class="col text-right">
                        <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import countries from '../../data/countries.json';
import { jobRoles } from '../../data/utils';

export default {
    name: 'Experience',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const { core_techstack_experience } = vm.$store.state.talent.talentData;

            if (!core_techstack_experience) vm.$router.back();
        });
    },
    props: {
        overview: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            countries,
            jobRoles,
            numLink: 0,
            education: [],
            company: [],
            work_experience: 0,
            error: '',
            remote_projects_links: [],
            projects_led_count: null,
            projects_led: [],
            project_leader: null,
        };
    },
    computed: {
        thisYear() {
            return Number(new Date().getFullYear());
        },
    },
    mounted() {
        const {
            work_experience,
            remote_projects_links,
            company,
            project_leader,
            projects_led_count,
            projects_led,
            education,
        } = this.$store.state.talent.talentData;

        this.work_experience = work_experience || 0;
        this.remote_projects_links = remote_projects_links || [];
        this.numLink = (remote_projects_links || []).length;
        this.company = (company || []).map(key => {
            const { Organization, organization, Role, role, Location, location, From, from, To, to, ID, id } = key;

            const fromDate = From || from;
            const toDate = To || to;

            const start_month = fromDate.split(' ')[0];
            const start_year = fromDate.split(' ')[1];
            const end_month = toDate.split(' ')[0];
            const end_year = toDate.split(' ')[1] || end_month;

            return {
                id: ID || id,
                organization: Organization || organization,
                role: Role || role,
                location: Location || location,
                from: fromDate,
                to: toDate,
                start_year,
                start_month,
                end_month,
                end_year,
            };
        });

        this.project_leader = Boolean(project_leader);
        this.projects_led_count = projects_led_count || 0;
        this.projects_led = projects_led || [];
        this.education = (education || []).map(key => {
            const { Institution, institution, Location, location, From, from, To, to, Course, course, ID, id } = key;

            const fromDate = From || from;
            const toDate = To || to;

            const start_month = fromDate.split(' ')[0];
            const start_year = fromDate.split(' ')[1];
            const end_month = toDate.split(' ')[0];
            const end_year = toDate.split(' ')[1] || end_month;

            return {
                id: ID || id,
                institution: Institution || institution,
                course: Course || course,
                location: Location || location,
                from: fromDate,
                to: toDate,
                start_year,
                start_month,
                end_month,
                end_year,
            };
        });
    },
    methods: {
        handleChange2(data) {
            let key = Object.keys(data);
            this.projects_led[Number(key) - 1] = data[key];
            this.$forceUpdate();
        },
        addEducation() {
            this.education = [
                ...this.education,
                {
                    id: 0,
                    institution: '',
                    course: '',
                    from: '',
                    to: '',
                },
            ];
        },
        removeEducation(i, id) {
            const vm = this;

            if (id) {
                vm.$confirm({
                    title: 'Are you sure?',
                    content: 'You are removing this education data!',
                    async onOk() {
                        return await deleteEducation();
                    },
                });
            } else splice();

            function splice() {
                vm.education.splice(i, 1);
                vm.storeEducationData();
            }

            async function deleteEducation() {
                const token = localStorage.getItem('token');
                try {
                    await vm.$api({
                        url: `/talents/profiles/education/${id}`,
                        method: 'delete',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    vm.showNotification('success', 'This education data has been removed', 'Successful');
                    splice();
                } catch (err) {
                    vm.catchErrors(err);
                }
            }
        },
        handleCompany(index, key, value) {
            this.company[index][key] = value;
            this.$forceUpdate();
        },
        storeCompanyData() {
            const { company } = this;
            this.$store.commit('talent/updateTalent', {
                company,
                work_experience: company.length,
            });
        },
        handleEducation(index, key, value) {
            this.education[index][key] = value;
            this.$forceUpdate();
        },
        storeEducationData() {
            const { education } = this;
            this.$store.commit('talent/updateTalent', {
                education,
            });
        },
        removeCompany(i, id) {
            const vm = this;

            if (id) {
                vm.$confirm({
                    title: 'Are you sure?',
                    content: 'You are removing this experience!',
                    async onOk() {
                        return await deleteCompany();
                    },
                });
            } else splice();

            function splice() {
                vm.company.splice(i, 1);
                vm.storeCompanyData();
            }

            async function deleteCompany() {
                const token = localStorage.getItem('token');
                try {
                    await vm.$api({
                        url: `/talents/profiles/company/${id}`,
                        method: 'delete',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    vm.showNotification('success', 'This experience has been removed', 'Successful');
                    splice();
                } catch (err) {
                    vm.catchErrors(err);
                }
            }
        },
        addCompany() {
            this.company = [
                ...this.company,
                {
                    id: 0,
                    organization: '',
                    from: '',
                    to: '',
                },
            ];
        },
        handleChange(data) {
            let key = Object.keys(data);
            this.remote_projects_links[Number(key) - 1] = data[key];
            this.$forceUpdate();
        },
        goBack() {
            this.$router.go(-1);
        },
        next() {
            const {
                // work_experience,
                remote_projects_links,
                // numLink,
                company,
                education,
                project_leader,
                projects_led_count,
                projects_led,
            } = this;

            const companyEmpty = company
                .map(key => {
                    const { organization, Organization, Role, role, Location, location, From, from, To, to } = key;

                    return !(organization || Organization) ||
                        !(role || Role) ||
                        !(location || Location) ||
                        !(from || From) ||
                        !(to || To)
                        ? 1
                        : 0;
                })
                .reduce((a, b) => a + b, 0);

            const educationEmpty = education
                .map(key => {
                    const { Institution, institution, Course, course, Location, location, From, from, to, To } = key;

                    return !(institution || Institution) ||
                        !(location || Location) ||
                        !(from || From) ||
                        !(to || To) ||
                        !(course || Course)
                        ? 1
                        : 0;
                })
                .reduce((a, b) => a + b, 0);

            this.error =
                // remote_projects_links.length !== numLink
                //   ? 'Enter links to all the remote projects you have completed'
                project_leader && !projects_led_count
                    ? "Enter the number of projects you've built as a team leader"
                    : projects_led_count && projects_led.length !== projects_led_count
                    ? 'Please enter all the links to the projects'
                    : education.length && educationEmpty > 0
                    ? `Please fill in all the details in education experience`
                    : company.length && companyEmpty > 0
                    ? `Please fill in all the details in company experience`
                    : '';

            if (this.error.length) {
                document.querySelector('.experience').scrollIntoView();
                return;
            }

            this.$store.commit('talent/addToTalent', {
                ...this.$store.state.talent.talentData,
                work_experience: company.length,
                remote_projects_links,
                company,
                education,
                project_leader: project_leader || false,
                projects_led_count,
                projects_led,
            });
            this.$router.push('devs');
        },
    },
    watch: {
        remote_projects_links() {
            const { remote_projects_links } = this;
            this.$store.commit('talent/updateTalent', {
                remote_projects_links,
            });
        },
        // education: {
        //   handler() {
        //     const { education } = this;
        //     this.$store.commit('talent/updateTalent', {
        //       education,
        //     });
        //   },
        //   deep: true,
        // },
        // company: {
        //   handler() {
        //     const { company } = this;
        //     this.$store.commit('talent/updateTalent', {
        //       company,
        //       work_experience: company.length,
        //     });
        //   },
        //   deep: true,
        // },
        project_leader() {
            const { project_leader } = this;
            this.$store.commit('talent/updateTalent', {
                project_leader,
            });
        },
        projects_led_count() {
            const { projects_led_count } = this;
            this.$store.commit('talent/updateTalent', {
                projects_led_count,
            });
        },
        projects_led() {
            const { projects_led } = this;
            this.$store.commit('talent/updateTalent', {
                projects_led,
            });
        },
    },
};
</script>
<style scoped>
.input {
    width: 90%;
    height: 50px;
    outline: 0;
    border: solid 1px #20409a;
    border-radius: 5px;
}
.control-width {
    width: 600px;
}

h3.kova-text {
    font-size: 20px;
}

.text-size2,
h5.kova-text {
    font-size: 16px;
}

.close {
    font-size: 18px;
    position: absolute;
    right: 20px;
    color: #fc0404;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
    .control-width {
        width: 500px;
    }
}
@media (max-width: 550px) {
    .control-width {
        width: 98%;
    }
}
</style>
